import { Dictionary } from 'rest-adapter/build/dist/Dictionary';
import { RangeFilterValue } from '../../../Filter/RangeFilterValue';
import { Attribute } from '../../../Model/Attribute';
import { ProductInterface } from '../../../Model/Product';
import { AttributeUtility } from '../../../Service/AttributeUtility';
import { RangeUtility } from '../../../Service/RangeUtility';

export class ForceSensorHelper {
    public static powerFilter(product: ProductInterface, value: RangeFilterValue) {
        return RangeUtility.areAttributesWithinRange(
            ForceSensorHelper.powerCollectAttributesOfProduct(product),
            value
        );
    }

    /**
     * Power attribute needs a special collect method because it's collected from the children's children
     *
     * @param {ProductInterface} product
     * @return {Attribute[]}
     */
    public static powerCollectAttributesOfProduct(product: ProductInterface): Attribute[] {
        if (!product.children) {
            return [];
        }

        return product.children.flatMap(
            child => AttributeUtility.attributesForKeyFiltered(child.children, 'A_PIM_Nennkraft')
        );
    }

    public static axisDiameterFilter(product: ProductInterface, value: RangeFilterValue) {
        return RangeUtility.areValuesWithinRange(
            AttributeUtility.childAttributesForKeyFiltered([product], 'Lagerinnendurchmesser')
                .map(a => parseInt(a.displayString, 10)),
            value
        );
    }

    public static rollerDiameterFilter(product: ProductInterface, value: RangeFilterValue): boolean {
        return RangeUtility.areAttributesWithinRange(
            ForceSensorHelper.rollerDiameterCollectAttributesOfProduct(product),
            value
        );
    }

    public static rollerDiameterCollectAttributesOfProduct(product: ProductInterface): Attribute[] {
        const attributes = AttributeUtility.attributesForKeyFiltered(product.children, 'Walzendurchmesser_MW');
        const dict: Dictionary = {};

        return attributes.filter(a => {
            if (dict[a.displayString]) {
                return false;
            }
            dict[a.displayString] = true;

            return true;
        });
    }

    public static rollerLengthFilter(product: ProductInterface, value: RangeFilterValue): boolean {
        return RangeUtility.areAttributesWithinRange(
            ForceSensorHelper.rollerLengthCollectAttributesOfProduct(product),
            value
        );
    }

    public static rollerLengthCollectAttributesOfProduct(product: ProductInterface): Attribute[] {
        const attributes = AttributeUtility.childAttributesForKeyFiltered(product.children, 'Walzenlaenge_MW');
        const dict: Dictionary = {};

        return attributes.filter(a => {
            if (dict[a.displayString]) {
                return false;
            }
            dict[a.displayString] = true;

            return true;
        });
    }
}
